import { useState } from 'react'

import { SelectOption } from 'components/Select'
import { CountryCode } from 'features/globalSetup/types/country'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { gql } from 'providers/tanstack-query/utils'

export const useGetCountryCodesOptions = (): {
  countryCodesOptions: SelectOption<CountryCode>[]
} => {
  const [result, setResult] = useState<SelectOption<CountryCode>[]>([])

  type Data = {
    geoEnum: CountryCode[]
  }

  useQuery<never, Data>({
    onCompleted: async (data: Data) => {
      if (data !== undefined) {
        setResult(
          data.geoEnum.map(
            (code: CountryCode): SelectOption<CountryCode> => ({
              label: code,
              value: code,
            }),
          ),
        )
      }
    },
    query: gql`
      query getGeoCodes {
        geoEnum
      }
    `,
  })

  return {
    countryCodesOptions: result,
  }
}
